import React from "react";
import classNames from "classnames";
import { scroller } from "react-scroll";
import { Link } from "react-router-dom";

const FooterNav = ({ className, ...props }) => {
  const classes = classNames("footer-nav", className);

  const scrollToSection = () => {
    window.location.replace("/#contactUs");
    scroller.scrollTo("contactUs", {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  return (
    <nav {...props} className={classes}>
      <ul className="list-reset">
        <li>
          <p
            className="link link-custom"
            onClick={() => {
              window.location.replace("/");
            }}
          >
            Home
          </p>
        </li>

        <li>
          <p className="link link-custom" onClick={scrollToSection}>
            Contact Us
          </p>
        </li>
        <li>
          <p
            className="link link-custom"
            onClick={() => {
              window.location.replace("/faqs");
            }}
          >
            FAQs
          </p>
        </li>

        {/* <li>
          <Link to="#0">Support</Link>
        </li> */}
      </ul>
    </nav>
  );
};

export default FooterNav;
